import React from 'react';
import { TextField, Button, Box, Typography, CircularProgress } from '@mui/material';
import { motion } from 'framer-motion';

const Step2 = ({ onNext, onBack, email, loading }) => {
  const [otp, setOtp] = React.useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onNext({ otp });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <form onSubmit={handleSubmit}>
        <Typography variant="h6" gutterBottom>
          Verify Email
        </Typography>
        <Typography variant="body1" color="textSecondary" gutterBottom>
          A verification code has been sent to <strong>{email}</strong>.
        </Typography>
        <TextField
          label="OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={onBack}
            disabled={loading}
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : 'Finish'}
          </Button>
        </Box>
      </form>
    </motion.div>
  );
};

export default Step2;